import { Primitive } from './Primitive';
import { Type } from './Type';
export class Mask3D extends Primitive {
    buffer;
    width;
    height;
    depth;
    constructor(buffer, shape) {
        super(Type.Mask3D);
        const [height, width, depth] = shape;
        this.height = height;
        this.width = width;
        this.depth = depth;
        this.buffer = buffer;
    }
    get shape() {
        return [this.height, this.width, this.depth];
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFzazNELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9NYXNrM0QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUN2QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sUUFBUSxDQUFBO0FBRTdCLE1BQU0sT0FBTyxNQUFPLFNBQVEsU0FBUztJQUMxQixNQUFNLENBQVk7SUFDbEIsS0FBSyxDQUFRO0lBQ2IsTUFBTSxDQUFRO0lBQ2QsS0FBSyxDQUFRO0lBRXRCLFlBQVksTUFBa0IsRUFBRSxLQUErQjtRQUM3RCxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQ2xCLE1BQU0sQ0FBQyxNQUFNLEVBQUUsS0FBSyxFQUFFLEtBQUssQ0FBQyxHQUFHLEtBQUssQ0FBQTtRQUNwQyxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtRQUNwQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtJQUN0QixDQUFDO0lBRUQsSUFBSSxLQUFLO1FBQ1AsT0FBTyxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDOUMsQ0FBQztDQUNGIn0=